module.exports = __webpack_public_path__ + "3fd6e546055426340b7afdaf2f17a932.png";